var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{attrs:{"format":_vm.format,"placeholder":"Select Date"},on:{"selected":_vm.dateSelect},model:{value:(_vm.vModelExample),callback:function ($$v) {_vm.vModelExample=$$v},expression:"vModelExample"}})
}
var staticRenderFns = []

export { render, staticRenderFns }